import { createStore, compose } from "redux";
import rootReducer from "./combineReducers";

const composeEnchancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnchancer());
// window.store = store;
export default store;
